import React from "react";
import { BackOfficeCard } from "../cards/BackOfficeCard";
import { InvoicesCard } from "../cards/InvoicesCard";
interface Props {}
export const MyTasksDetails: React.FC<Props> = () => {
  return (
    <>
      <h1 className="mr-auto font-semibold text-primary text-md mb-2">
        My Tasks
      </h1>
      <div className="grid gap-3 grid-cols-2">
        <InvoicesCard />
        <BackOfficeCard />
      </div>
    </>
  );
};
